@use "diy_base.module.scss";
@use "foundation/_mixins.scss";
@use "foundation/responsive";
@use "foundation/typography_base";
@use "sass:math";

a.add {
  width: 40px;
  height: 40px;
  cursor: pointer;

  span > svg {
    width: 40px;
    height: 40px;
  }
}

button.add {
  width: 40px;
  height: 40px;
  cursor: pointer;

  span > svg {
    width: 40px;
    height: 40px;
  }
  @include responsive.phone {
    width: 28px;
    height: 28px;

    span > svg {
      width: 28px;
      height: 28px;
    }
  }
}

.add-new-query-filter-delay {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  @include diy_base.box-border;

  width: diy_base.$box-width;
  border-color: #EEE;

  @include responsive.phone {
    width: diy_base.$box-width-phone;
  }

  div.add-query,
  div.add-filter,
  div.add-delay  {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;

    width: 100%;
    padding: 1.25em; /* to use border here */
    cursor: pointer;

    h4 {
      margin: 0;

      @include responsive.phone {
        // https://app.shortcut.com/ifttt/story/97659/web-delay-ui-bugs#activity-98926
        // also, the txt-body-3 class cannot be @extended across a media query
        font-weight: 700;
        font-size: math.div(16px, typography_base.$small-desktop-font-size) * 1rem;
        line-height: math.div(28px, typography_base.$small-desktop-font-size) * 1rem;
      }
    }

    p {
      margin: unset;
      margin-top: .25em;

      @include responsive.phone {
        display: none;
      }
    }
  }

  span.badge {
    padding-left: .5em;
    padding-top: .2em;
  }

  div.title {
    display: flex;

    .badge.pro_plus {
      @include mixins.ifttt-logo-with-tier-badge;
      justify-content: flex-start;

      width: auto;
      padding-top: unset;

      svg {
        /* same new badge height */
        height: 21px !important;
      }
    }
  }

  div.add-query,
  div.add-filter {
    border-bottom: 1px solid #EEE;
  }
}
